const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// noinspection JSUnusedGlobalSymbols
export default sleep;
